import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductBatchService = {
  async getByBatchNo(batchNo, itemCode, branchCode) {
    const requestScreenData = {
      url: "api/ConsumeProductBatch",
      top: "1",
      filter: `BatchNo eq '${batchNo}' and ItemCode eq '${itemCode}' and BranchCode eq '${branchCode}' and SourceTransactionType eq '' and SourceTransactionNo eq 0 and SourceTransactionLine eq 0 and SourceTransactionProcessCode eq '' `,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async getAllBatchNo(getFilter, params, BranchCode) {

    var filter = `(SourceTransactionType eq '') and (SourceTransactionNo eq 0) and (SourceTransactionLine eq 0) and (SourceTransactionProcessCode eq '')`;
    if (getFilter) {
      filter = filter + ` and (${getFilter})`
    }

    if (BranchCode) filter += ` and BranchCode eq '${BranchCode}'`;
    const requestScreenData = {
      url: "api/ConsumeProductBatch",
      filter: filter,
    };
    if (params) {
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }

    return await ApiService.oDataGet(requestScreenData);

  },
  async getAllBatchNoByBranch(getFilter, branchCode, select) {

    var filter = `(SourceTransactionType eq '') and (SourceTransactionNo eq 0) and (SourceTransactionLine eq 0) and (SourceTransactionProcessCode eq '') and (BranchCode eq '${branchCode}')`;
    if (getFilter) {
      filter = filter + ` and (${getFilter})`
    }
    const requestScreenData = {
      url: "api/ConsumeProductBatch",
      filter: filter,
      orderby: 'UseByDateForSort asc,BestBeforeDateForSort asc,DateCreated asc',
      select: select
    };

    return await ApiService.oDataGet(requestScreenData);

  },

  async getBatchItems(filter) {
    const requestScreenData = {
      url: "api/ProductBatchStock",
      filter: filter,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getBatchDataItems(getFilter) {
    var filter = `(SourceTransactionType eq '') and (SourceTransactionNo eq 0) and (SourceTransactionLine eq 0) and (SourceTransactionProcessCode eq '')`;
    if (getFilter) {
      filter = filter + ` and (${getFilter})`
    }
    const requestScreenData = {
      url: "api/ConsumeProductBatch",
      filter: filter,
      orderby: 'UseByDateForSort asc,BestBeforeDateForSort asc,DateCreated asc',
    };

    return await ApiService.oDataGet(requestScreenData);
  }
};

export { ProductBatchService };
